import jQuery from 'jquery'
import 'slick-carousel'

export default class SolutionsCarousel {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.gallery = jQuery('.s-solutions-carousel__items', this.$element)

    this.gallery.slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 1300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 4000,
    })
  }
}
